import $ from 'jquery'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import { Alert } from '../functions'

const object = vnObject

const updatePasswordForm = $('.js-update-password-form')

if (updatePasswordForm.length) {
    updatePasswordForm.parsley().on('form:success', function () {
        updatePasswordForm.attr('data-success', 'true')
    })

    updatePasswordForm.parsley().on('form:error', function () {
        updatePasswordForm.attr('data-success', 'false')
    })

    updatePasswordForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(updatePasswordForm[0])
        formData.append('action', 'vn_update_password')
        formData.append('nonce', object.nonce)

        const $form = $(this)
        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            data: formData,
            beforeSend: () => {
                $form.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            processData: false,
            contentType: false,
            success: (res) => {
                $form.removeClass('sending')
                Alert(res.success, res.data.message)
            },
        })
    })
}
